<template>
  <div>
    <el-container>
      <el-header class="header" style="height: 136px">
        <div class="top-img-box">
          <img
            style="width: 441px; height: 62px; margin-left: 155px"
            src="../../assets/evidence_img/top_icon.png"
          />
        </div>
      </el-header>
      <el-main>
        <div class="main">
          <el-row class="flex justify-center">
            <el-col :span="20" class="p-t-100">
              <div class="content-box bg-white p-50">
                <div class="content-box-top flex align-center">
                  <img
                    class="title-left-bar"
                    src="../../assets/evidence_img/title_left_bar.png"
                    alt=""
                  />
                  <span class="top-title p-l-20">密码登录</span>
                  <button class="login-btn m-l-50">密码登录</button>
                </div>
                <div class="content-box-main flex align-start p-t-20">
                  <div class="content-box-main-left flex-sub p-relative">
                    <el-image
                      style="height: 520px"
                      fit="cover"
                      :src="require('../../assets/evidence_img/bg.png')"
                    ></el-image>
                    <div class="msg">
                      网页取证是一款针对静态网页进行证据保全的在线取证工具，通过公证处服务器实时截图固定网页内容并将其封存，形成具备公证效力的电子证据。
                    </div>
                  </div>
                  <div class="content-box-main-right flex-sub">
                    <div class="login-box p-50">
                      <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        class="demo-ruleForm"
                      >
                        <div class="item-title flex align-center m-b-30">
                          <img
                            class="item-left-bar"
                            src="../../assets/evidence_img/item_left_bar.png"
                            alt=""
                          />
                          <span class="p-l-15">密码登录</span>
                        </div>
                        <el-form-item prop="account" class="p-b-10">
                          <div
                            class="
                              login-msg-input-box
                              p-x-10 p-y-10
                              flex
                              align-center
                            "
                          >
                            <img
                              class="phone-icon"
                              src="../../assets/evidence_img/phone_icon.png"
                              alt=""
                            /><el-input
                              v-model="ruleForm.account"
                              placeholder="请输入账号"
                            ></el-input>
                          </div>
                        </el-form-item>
                        <el-form-item prop="password" class="p-b-10">
                          <div
                            class="
                              login-msg-input-box
                              p-x-10 p-y-10
                              flex
                              align-center
                            "
                          >
                            <img
                              class="lock-icon"
                              src="../../assets/evidence_img/lock_icon.png"
                              alt=""
                            /><el-input
                              type="password"
                              v-model="ruleForm.password"
                              placeholder="请输入密码"
                            ></el-input>
                          </div>
                        </el-form-item>
                        <el-form-item prop="captcha" class="p-b-10">
                          <div class="flex align-center">
                            <div
                              class="
                                login-msg-input-box
                                p-x-10 p-y-10
                                flex
                                align-center
                              "
                            >
                              <img
                                class="captcha-icon"
                                src="../../assets/evidence_img/captcha_icon.png"
                                alt=""
                              />
                              <el-input
                                v-model="ruleForm.captcha"
                                placeholder="请输入验证码"
                              ></el-input>
                            </div>
                            <span class="p-l-20 flex" @click="replaceCaptcha">
                              <img
                                :src="
                                  'data:image/png;base64,' + captchaBase64Img
                                "
                                class="captcha-img"
                              />
                            </span>
                            <span
                              class="text-blue captcha-text p-l-10"
                              @click="replaceCaptcha"
                              >换一张</span
                            >
                          </div>
                        </el-form-item>
                        <el-form-item>
                          <div class="">
                            <el-button
                              :disabled="!checkOk"
                              class="width-fill commit-btn"
                              :type="checkOk ? 'primary' : 'info'"
                              @click="login"
                              >登录</el-button
                            >
                          </div>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <div></div>
        </div>
      </el-main>
      <el-footer class="footer" style="height: 410px">
        <div class="p-y-30 flex justify-center">
          <div
            class="
              flex-sub flex
              justify-center
              align-self-stretch align-start
              p-x-15
            "
            style="width: 300px"
          >
            <div style="margin: 0 auto">
              <div class="fontsize-18 fontweight-bold p-b-24">工作时间</div>
              <div>
                <div class="flex p-b-24">
                  <div class="fontsize-16 p-r-10 label-left">工作日</div>
                  <span class="fontsize-14">上午9:00 - 12:00</span>
                </div>
                <div class="p-b-24">
                  <span class="fontsize-14 time-msg">下午13:00 - 18:00</span>
                </div>
              </div>
              <div>
                <div class="flex p-b-24">
                  <div class="fontsize-16 p-r-10 label-left">周六</div>
                  <span class="fontsize-14">上午9:00 - 12:00</span>
                </div>
                <div class="p-b-24">
                  <span class="fontsize-14 time-msg">下午13:00 - 16:00</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              flex-sub flex
              align-self-stretch align-start
              justify-center
              p-x-15
            "
          >
            <div style="margin: 0 auto">
              <div class="fontsize-18 fontweight-bold p-b-24">联系方式</div>
              <div class="">
                <div class="p-b-24 flex align-center">
                  <img
                    class="tel-icon"
                    src="../../assets/evidence_img/tel_icon.png"
                    alt=""
                  />
                  <span class="p-l-20">020-86100999</span>
                </div>
                <div class="p-b-24 p-l-40">020-86100991</div>
                <div class="p-b-24 flex align-center">
                  <img
                    class="mail-icon"
                    src="../../assets/evidence_img/mail_icon.png"
                    alt=""
                  /><span class="p-l-20">zngzc@zngzc.com</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-sub flex justify-center">
            <div class="flex justify-center" style="width: 500px">
              <div class="icon-box flex flex-direction">
                <img
                  class="m-b-20 ear-icon"
                  src="../../assets/evidence_img/ear_icon.png"
                  alt=""
                />
                <img
                  class="mail-icon"
                  src="../../assets/evidence_img/locate_icon.png"
                  alt=""
                />
              </div>
              <div class="p-x-20">
                <img
                  class="qrcode"
                  src="../../assets/evidence_img/qrcode.png"
                  alt=""
                />
                <div class="text-center fontsize-18 p-20">扫码办证</div>
              </div>
              <div class="p-x-20">
                <img
                  class="qrcode"
                  src="../../assets/evidence_img/qrcode.png"
                  alt=""
                />
                <div class="text-center fontsize-18 p-20">中南公证处资讯</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-center p-35">
          <span class="bottom-nav">首页</span>
          <div class="center-line"></div>
          <span class="bottom-nav">机构信息</span>
          <div class="center-line"></div>
          <span class="bottom-nav">资讯动态</span>
          <div class="center-line"></div>
          <span class="bottom-nav">办证指南</span>
          <div class="center-line"></div>
          <span class="bottom-nav">资料下载</span>
        </div>
        <div class="text-center p-30 bottom-box">
          广东省广州市中南公证处©2021版权所有 粤ICP备20048095号
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { getCaptcha } from "@/api/system/login";
export default {
  data() {
    // var validatePhone = (rule, value, callback) => {
    //   let reg_phone =
    //     /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    //   if (!value.trim()) {
    //     this.check_res.account = false;
    //     callback(new Error("手机号码不能为空"));
    //   } else if (!reg_phone.test(value)) {
    //     this.check_res.account = false;
    //     callback(new Error("请检查手机号是否输入有误！"));
    //   } else {
    //     this.check_res.account = true;
    //     this.$refs.ruleForm.validateField("checkPhone");
    //     callback();
    //   }
    // };
    var validatePassword = (rule, value, callback) => {
      if (!value.trim()) {
        this.check_res.password = false;
        callback(new Error("密码不能为空"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.check_res.password = true;
          this.$refs.ruleForm.validateField("Password");
        }
        callback();
      }
    };
    return {
      captchaBase64Img: "",
      ruleForm: {
        account: "",
        password: "",
        captcha: "",
        captcha_token: "",
      },
      check_res: {
        account: false,
        password: false,
        captcha: false,
      },
      rules: {
        account: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
        captcha: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    "ruleForm.captcha"(n, o) {
      if (n.trim()) {
        this.check_res.captcha = true;
      } else {
        this.check_res.captcha = false;
      }
    },
  },
  computed: {
    checkOk() {
      // if (
      //   this.check_res.account &&
      //   this.check_res.password &&
      //   this.check_res.captcha
      // ) {
      //   return true;
      // }
      if (
        this.ruleForm.account &&
        this.ruleForm.password &&
        this.ruleForm.captcha
      ) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.replaceCaptcha();
  },
  methods: {
    // 获取验证码
    replaceCaptcha() {
      getCaptcha().then((res) => {
        this.ruleForm.captcha_token = res.data.captcha_token;
        this.captchaBase64Img = res.data.captcha_base64_img;
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 登录
    login() {
      let that = this
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // this.ruleForm.user_name.trim();
          this.$store
            .dispatch("Login", this.ruleForm)
            .then((res) => {
              console.debug("login", res);
              this.loading = false;
              that.$router
                .push({
                  path: "/evidence",
                })
                .catch((err) => {
                  console.debug(err);
                });
            })
            .catch(() => {
              this.loading = false;
              this.replaceCaptcha();
            });
        } else {
          return false;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/public-style.scss";
.header {
  height: 136px;
  .top-img-box {
    height: 100%;
    display: flex;
    align-items: center;
  }
}
.main {
  height: 850px;
  background: url(../../assets/evidence_img/bg.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 60px;
  .content-box {
    min-width: 800px;
    opacity: 0.98;
    border-radius: 10px;
    .content-box-top {
      .title-left-bar {
        width: 5px;
        height: 25px;
      }
      .top-title {
        font-size: 22px;
        font-weight: 500;
        color: #333333;
        line-height: 30px;
      }
      .login-btn {
        width: 118px;
        height: 40px;
        border: 1px solid #ff8241;
        background: none;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 500;
        color: #ff8241;
      }
    }
    .content-box-main {
      .content-box-main-left {
        width: 50%;
        /* min-height: 300px;
        border-radius: 10px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat; */
        border-radius: 10px;
        .msg {
          position: absolute;
          bottom: 0;
          padding: 20px;
          background: #000000;
          opacity: 0.5;
          border-radius: 10px 10px 0 0;
          color: white;
        }
      }
      .content-box-main-right {
        width: 50%;
        .login-box {
          margin: 0 auto;
          width: 80%;
          min-width: 350px;
          /* height: 620px; */
          background: #ffffff;
          border: 1px solid #ffffff;
          border-radius: 4px;
          box-shadow: 0 0 20px 1px #ebecef;
          .item-title {
            font-size: 18px;
            font-weight: 400;
            color: #ff7800;
          }
          .item-left-bar {
            width: 4px;
            height: 18px;
          }
          /deep/.el-form-item__error {
            padding-left: 20px;
          }
          .login-msg-input-box {
            background: #f8f8f8;
            border-radius: 4px;
            .phone-icon {
              width: 17px;
              height: 26px;
            }
            .lock-icon,
            .captcha-icon {
              width: 17px;
              height: 20px;
            }
            .el-input {
              width: unset;
            }
            /deep/.el-input--medium .el-input__inner {
              background-color: rgba(0, 0, 0, 0);
              border: 0;
            }
          }
          .captcha-img {
            width: 125px;
            height: 40px;
          }
          .captcha-text {
            font-size: 14px;
            font-weight: 400;
            color: #0063ff;
            cursor: pointer;
          }
          .commit-btn {
            height: 50px;
            font-size: 22px;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
}
.footer {
  padding: 0;
  background: #e6ebed;
  .bottom-box {
    background-color: #002d74;
    color: white;
  }
  .bottom-nav {
    text-decoration: underline;
    cursor: pointer;
    padding: 0 35px;
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
  }
  .center-line {
    width: 1px;
    height: 12px;
    background: #000000;
    opacity: 0.59;
  }
  .label-left {
    width: 80px;
  }
  .time-msg {
    padding-left: 80px;
  }
  .tel-icon,
  .mail-icon {
    width: 20px;
    height: 15px;
  }
  .icon-box {
    height: 100%;
    padding-bottom: 50px;
    .ear-icon {
      width: 30px;
      height: 30px;
    }
    .mail-icon {
      width: 26px;
      height: 30px;
    }
  }
  .qrcode {
    width: 189px;
    height: 176px;
    margin: 0 auto;
  }
}
</style>
